<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12 col-xl-10">
				<div class="row align-items-center justify-content-between">
					<div class="col-12 col-lg-4">
						<h4 class="mm-0 mb-4">Notification management</h4>
					</div><!--col-->
				</div><!--row-->
			</div><!--col-->
		</div><!--row-->
		<div class="row">
			<div class="col-12 col-xl-7">
				
				<div class="table-responsive">
					<table class="table table-bordered">
						<thead>
							<tr>
								<th class="">Name</th>
								<th>Email/Push</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in notifications" >
								<td><router-link :to="{ name: 'admin.notification-management.edit', params : { id : item.id } }" 
										tag="a" class="bold">{{ item.name }}</router-link>
								</td>
								<td>
									{{item.email_str}}/{{item.push_str}}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div><!--col-->
		</div><!--row-->
	</div><!--container-->
</template>

<script>
	export default {
		data : function(){
			return {
				notifications : []
			}
		},

		created : function(){
			this.getNotificationManagement();
		},

		methods : {

			getNotificationManagement : function() {

				var params = {
					filters : {
						
					}
				}
				
				this.$store.dispatch('getNotificationManagement', params).then((res) => {
					this.notifications = res.data.data;
				}).catch((error) => {
					console.log(error);
				});
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/admin/notification_management/AdminNotificationManagementListComponent.vue